// extracted by mini-css-extract-plugin
export default {"container":"rQ-z","topReviewHeading":"sQ-z","criticalReview":"tQ-z","favorableReview":"uQ-z","vsSeparator":"vQ-z"};